import React from 'react';
import { ChevronLeft, TodoList2 } from 'shared/assets/icons';
import { GoalSectionContextMenu } from 'shared/components/connected/goal-section-context-menu';
import { Icon } from 'shared/components/ui/icon';
import { Colors, IconButton, Sizes } from 'shared/components/ui/icon-button';
import { useContextMenuState } from 'shared/hooks/use-context-menu-state';
import { Goal } from 'shared/types/goal';
import { GoalSection } from 'shared/types/goal-section';

import * as Styled from './goal-item-card.style';

export type GoalSectionItemCardProps = {
  section: GoalSection;
  goal: Goal;

  onCollapse?: (e: React.MouseEvent) => void;
  collapsed?: boolean;
  isGrabbable?: boolean;
  isGrabbed?: boolean;
};

export const GoalSectionItemCard: React.FC<GoalSectionItemCardProps> = ({
  section,
  goal,
  onCollapse,
  collapsed,
  isGrabbable,
  isGrabbed,
}) => {
  const {
    open: openMenu,
    close: closeMenu,
    position: menuPosition,
  } = useContextMenuState({
    disabled: !!goal.frozenAt,
  });

  const _onClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onCollapse?.(e);
  };

  return (
    <>
      <Styled.Container
        $isGrabbable={!!isGrabbable}
        $isGrabbed={!!isGrabbed}
        onClick={_onClick}
        onContextMenu={openMenu}
      >
        <Styled.Content>
          <Styled.IllustrationContainer>
            <Styled.IconContainer>
              <Icon icon={TodoList2} />
            </Styled.IconContainer>
          </Styled.IllustrationContainer>

          <Styled.Title>{section.name}</Styled.Title>
        </Styled.Content>

        <Styled.MetaContainer>
          {!!onCollapse && (
            <IconButton
              size={Sizes.Small}
              icon={ChevronLeft}
              rotation={collapsed ? -90 : 0}
              color={Colors.Default}
              as="span"
            />
          )}
        </Styled.MetaContainer>
      </Styled.Container>

      {!!menuPosition && (
        <GoalSectionContextMenu
          id={section.id}
          goalId={goal.id}
          onClose={closeMenu}
          location={menuPosition}
        />
      )}
    </>
  );
};
